import React, { useState } from 'react'
import { Drawer, Button, Checkbox, Row, Col } from 'antd'
import { FaArrowLeft } from 'react-icons/fa' // Importing the back icon
import DetailDrawer from './DetailDrawer'
import { RiCloseLine } from 'react-icons/ri'
import { translations } from '../../utils/constants'

const ReportDrawer = ({ isVisible, onClose, title, language }) => {
    const [isDetailDrawerVisible, setIsDetailDrawerVisible] = useState(false)

    const checkboxOptions = [
        { label: translations[language]?.datetxt, value: 'Date' },
        { label: translations[language]?.vechiclelabel, value: 'Vehicle' },
        { label: translations[language]?.profitloss, value: 'Profit/loss' },
        { label: translations[language]?.fueltxt, value: 'Fuel' },
        { label: translations[language]?.devicesTabletxt, value: 'Devices' },
        { label: translations[language]?.installDate, value: 'Installation Date' },
    ]

    const handleGenerateReport = () => {
        setIsDetailDrawerVisible(true)
        onClose()
    }

    return (
        <>
            <Drawer
                title={title}
                visible={isVisible}
                onClose={onClose}
                width={750}
                placement="right"
                closable={true}
                className="custom-drawer detail-drawer"
                closeIcon={<span className="custom-close-icon"><RiCloseLine /></span>}
                style={{ zIndex: 1000 }}
            >
                <Row gutter={16}>
                    {checkboxOptions.map((option, index) => (
                        <Col span={12} key={index}>
                            <Checkbox value={option?.value}>{option?.label}</Checkbox>
                        </Col>
                    ))}
                </Row>
                <div className="report-drawer-btn-div">
                    <Row gutter={16}>
                        <Col>
                            <Button className="report-clear-btn" onClick={onClose}>
                                {translations[language]?.cancelButton}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                className="report-apply-btn"
                                type="primary"
                                onClick={handleGenerateReport}
                            >
                                {translations[language]?.generateTxt}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Drawer>

            {isDetailDrawerVisible && (
                <DetailDrawer
                    isVisible={isDetailDrawerVisible}
                    onClose={() => setIsDetailDrawerVisible(false)}
                    language={language}
                />
            )}
        </>
    )
}

export default ReportDrawer
